<div class="camera-file-container">
  <!-- Foto capturada ou arquivo enviado -->
  <div *ngIf="(capturedPhoto || uploadedFile) && !isCameraActive" class="preview-section">
    <!-- Preview da foto -->
    <div *ngIf="capturedPhoto" class="photo-preview">
      <img [src]="capturedPhoto" alt="Captured photo" class="captured-image" />
      <div class="preview-actions">
        <button mat-raised-button (click)="removePhoto()">
          <mat-icon>delete</mat-icon>
          Remover foto
        </button>
      </div>
    </div>

    <!-- Preview do arquivo -->
    <div *ngIf="uploadedFile" class="file-preview">
      <div class="file-info">
        <mat-icon>insert_drive_file</mat-icon>
        <span class="file-name">{{ fileName }}</span>
      </div>
      <div class="file-actions">
        <button mat-raised-button (click)="removeFile()">
          <mat-icon>delete</mat-icon>
          Remover arquivo
        </button>
      </div>
    </div>
  </div>

  <!-- Câmera ativa -->
  <div *ngIf="isCameraActive" class="camera-section">
    <div class="camera-view">
      <video
        #videoElement
        autoplay
        playsinline
        class="video-element"
      ></video>
    </div>

    <div class="camera-controls" *ngIf="!isLoading">
      <button
        mat-fab
        color="primary"
        (click)="capturePhoto()"
        [disabled]="isLoading"
        class="capture-btn"
        aria-label="Capture photo"
      >
        <mat-icon>camera</mat-icon>
      </button>

      <button
        *ngIf="hasMultipleCameras"
        mat-mini-fab
        (click)="switchCamera()"
        [disabled]="isLoading"
        class="switch-btn"
        aria-label="Switch camera"
      >
        <mat-icon>flip_camera_android</mat-icon>
      </button>

      <button
        mat-mini-fab
        color="warn"
        (click)="stopCamera()"
        [disabled]="isLoading"
        class="close-btn"
        aria-label="Close camera"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Botões de ação quando não há arquivo/foto -->
  <div *ngIf="!capturedPhoto && !uploadedFile && !isCameraActive" class="action-buttons">
    <button
      mat-raised-button
      (click)="startCamera()"
      [disabled]="isLoading"
      class="action-btn camera-btn"
    >
      <mat-icon>camera_alt</mat-icon>
      Tirar foto
    </button>

    <span class="separator">ou</span>

    <button
      mat-raised-button
      (click)="openUploadModal()"
      [disabled]="isLoading"
      class="action-btn upload-btn"
    >
      <mat-icon>upload_file</mat-icon>
      Selecionar arquivo
    </button>
  </div>

  <!-- Loading spinner -->
  <div *ngIf="isLoading" class="loading-overlay">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
</div>
